import React from 'react';

function Divider() {
  return <div className='streamfield divider' />;
}

export default Divider;
